import React from "react";
import { useEffect, useState, useRef } from "react";
import { Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { AppHelpers } from "../../Helpers/App/AppHelpers";
import {
  InputControl,
  TextAreaControl,
  SelectControl,
  Modal,
  Loading,
  toastSuccessMessage,
} from "wup-module1-base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BookingCalendar } from "wup-module1-base";
import { ContactService, CalendarService } from "../../Services";
import moment from "moment";
import { faCircleCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const ContactModal = (data) => {
  const bookingSuccessMessage = "Umówiono na spotkanie";
  const sendMailSuccessMessage = "Mail został wysłany";

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isSubmittingSelection, setIsSubmittingSelection] = useState(false);

  const [showHourSelection, setShowHourSelection] = useState(false);
  const [calendarIsOpen, setOpenCalendar] = useState(false);
  const [noAvailableDates, setNoAvailableDates] = useState(false);
  const [listOfMeeting, setListOfMetting] = useState(false);
  const [dateShow, setDateShow] = useState(false);

  const [listOfEvent, setListOfEvent] = useState(false);
  const [selectedMeeting, setSelectedMetting] = useState();
  const [selectedHour, setSelectedHour] = useState();
  const [selectedDate, setSelectedDate] = useState();

  const [inputIsOpen, setOpenInput] = useState(false);
  const [selectLoad, setSelectLoad] = useState(false);
  const [responseListOfProblem, setResponseListOfProblem] = useState();
  const [listOfProblem, setListOfProblem] = useState();

  const [problemId, setProblemId] = useState(false);

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const calendarRef = useRef(null);

  useEffect(() => {
    let events = [];

    setSelectLoad(true);

    ContactService.getProblemForForm()
      .then((response) => {
        setResponseListOfProblem(response.data);

        const listOfProblems = [{ name: "Wybierz temat...", value: 0 }];

        response.data.forEach((item) => {
          listOfProblems.push({ name: item.name, value: item.id });
        });

        setListOfProblem(listOfProblems);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setSelectLoad(false);
      });
  }, []);

  function setProblem(id) {
    const val = Number(id);

    if (!val || val === 0) {
      setProblemId(0);
      setOpenCalendar(false);
      setOpenInput(false);
      setShowHourSelection(false);
      setSelectedMetting(undefined);
      setSelectedHour(undefined);
      setSelectedDate(undefined);
      return;
    }

    setProblemId(id);

    let problem = responseListOfProblem.find((item) => item.id == id);

    if (problem.is_consultation === true) {
      setOpenCalendar(true);
      setOpenInput(false);
      openCalendar();
    } else {
      setOpenCalendar(false);
      setOpenInput(true);
    }
  }

  const openCalendar = () => {
    setIsSubmitting(true);
    let events = [];
    CalendarService.getFreeCalendar(1)
      .then((response) => {
        response.data.forEach((item) => {
          let date = moment(item.date_from).format("YYYY-MM-DD");

          if (
            !events.some(
              (event) => moment(event.start).format("YYYY-MM-DD") === date
            )
          ) {
            events.push({
              title: "",
              start: date,
              display: "background",
              color: "green",
            });
          }
        });

        if (response.data === null) {
          setNoAvailableDates(true);
        }

        setListOfEvent(events);
      })
      .catch((error) => {
        setNoAvailableDates(true);
        console.error(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  function confirmMetting() {
    const dataStore = {
      meeting_id: selectedMeeting,
    };

    CalendarService.bookingMeeting(data.userId, dataStore)
      .then((response) => {
        toastSuccessMessage(bookingSuccessMessage);
      })
      .catch((error) => {
        if (
          error.response?.status === 400 ||
          error.response?.status === 422 ||
          error.response?.status === 500
        ) {
          toast.error(
            <div>
              Nie udało się umówić na konsultacje z doradcą. Wybrany termin jest
              już niedostępny.
            </div>,
            {
              position: "top-right",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
        console.error(error);
      })
      .finally(() => {
        data.setOpenContactModal(false);
        setOpenCalendar(false);
        setShowHourSelection(false);
      });
  }

  function sendEmial() {
    setIsLoadingButton(true);

    const dataMail = {
      title: title,
      content: content,
    };

    ContactService.contactFormMailMessage(data.userId, dataMail)
      .then((response) => {
        toastSuccessMessage(sendMailSuccessMessage);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Wystąpił błąd podczas próby wysłania e-mail");
      })
      .finally(() => {
        setIsLoadingButton(false);
        data.setOpenContactModal(false);
        setOpenInput(false);
        setTitle("");
        setContent("");
      });
  }

  function setMetting(id) {
    if (id !== null) {
      let hourValue = listOfMeeting.find((item) => item.value == id);
      setSelectedHour(hourValue.name);
      setDateShow(true);
      setSelectedMetting(id);
    }
  }

  const setDataForCalendar = (arg) => {
    setDateShow(false);

    setIsSubmittingSelection(true);

    if (calendarRef.current) {
      const currentDateFormatted = moment(arg.date).format("YYYY-MM-DD");

      const dateFormatted = moment(arg.date).format("DD.MM.YYYY");

      setSelectedDate(dateFormatted);

      CalendarService.getFreeCalendarDate(1, currentDateFormatted)
        .then((response) => {
          const listOfMeeting = [{ name: "", value: 0 }];

          response.data.forEach((item) => {
            let startDate = new Date(item.date_from);
            let endDate = new Date(item.date_to);

            listOfMeeting.push({
              name:
                "od " +
                startDate.toLocaleTimeString().slice(0, 5) +
                " do " +
                endDate.toLocaleTimeString().slice(0, 5),
              value: item.id,
            });
          });

          setSelectedMetting(listOfMeeting[0].value);
          setSelectedHour(listOfMeeting[0].name);
          setListOfMetting(listOfMeeting);
          setShowHourSelection(true);
        })
        .catch((error) => {
          setShowHourSelection(false);
          toast.error("Terminy w wybranym dniu są już niedostępne.");
          openCalendar();
          console.error(error);
        })
        .finally(() => {
          setIsSubmittingSelection(false);
          setDateShow(false);
        });
    }
  };

  const handleHideFormContact = () => {
    setShowHourSelection(false);
    setOpenCalendar(false);
    setOpenInput(false);
    data.setOpenContactModal(false);
  };

  return (
    <>
      {selectLoad ? (
        <Loading className="px-1 mr-3 nav-link" size="sm" />
      ) : (
        <>
          <Modal
            show={data.contactModalIsOpen}
            size={"default"}
            enforceFocus={true}
            className={"modal-p10"}
          >
            <Button
              type="button"
              variant="primary"
              className="float-right focusable simple-btn"
              aria-label="Zamknij formularz kontaktu"
              onClick={handleHideFormContact}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Button>
            <div class="modal-header"><div class="modal-title h4">Formularz kontaktu</div></div>

            <div className="centered">
              <h6 className="text-contact-modal">Określ temat:</h6>
              <SelectControl
                options={listOfProblem}
                ignoreLabel={true}
                onChange={setProblem}
              />
            </div>

            {calendarIsOpen ? (
              <>
                {isSubmitting ? (
                  <Loading size="lg" className="px-10" variant="dark" />
                ) : (
                  <>
                    {noAvailableDates ? (
                      <>
                        <div className="centered">
                          <h2>Brak wolnych terminów</h2>
                        </div>
                      </>
                    ) : (
                      <>
                        <h5 className="text-color">Wskaż Termin spotkania</h5>
                        <BookingCalendar
                          calendarRef={calendarRef}
                          onDateChange={setDataForCalendar}
                          events={listOfEvent}
                        />
                        {showHourSelection ? (
                          <>
                            {isSubmittingSelection ? (
                              <Loading
                                size="lg"
                                className="px-10"
                                variant="dark"
                                style={{ marginTop: "20px" }}
                              />
                            ) : (
                              <>
                                <br />
                                <div className="centered">
                                  <h6 className="text-color-time-1">
                                    Wybierz godzinę:
                                  </h6>
                                  <SelectControl
                                    options={listOfMeeting}
                                    onChange={setMetting}
                                    ignoreLabel={true}
                                  />
                                </div>
                                {dateShow ? (
                                  <div className="centered">
                                    <h6 className="text-color-time-2">
                                      Wybrano termin:{" "}
                                    </h6>{" "}
                                    {selectedDate} {selectedHour}
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {isSubmittingSelection ? (
                              <div className="centered">
                                <Loading
                                  size="lg"
                                  className="px-10"
                                  variant="dark"
                                />
                              </div>
                            ) : (
                              <div className="centered">
                                <h2>Brak wolnych terminów</h2>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

                {showHourSelection ? (
                  <Button
                    type="button"
                    variant="primary"
                    className="float-right simple-btn focusable"
                    onClick={confirmMetting}
                    aria-label="Potwierdź spotkanie"
                  >
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      className="accept-cancel-button-icon"
                    />
                  </Button>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}

            {inputIsOpen ? (
              <>
                <Col md={12}>
                  <InputControl
                    id={"titleInput"}
                    label={"Temat"}
                    value={title}
                    onChange={setTitle}
                  />
                </Col>
                <Col md={12}>
                  <TextAreaControl
                    id={"contentInput"}
                    label={"Treść"}
                    readOnly={false}
                    value={content}
                    onChange={setContent}
                  />
                </Col>

                {isLoadingButton ? (
                  <Button
                    className="float-right contact-modal-btn-add"
                    onClick={sendEmial}
                  >
                    <Loading size="sm" className="px-3" variant="light" />
                  </Button>
                ) : (
                  <Button
                    className="float-right contact-modal-btn-add"
                    onClick={sendEmial}
                  >
                    Wyślij
                  </Button>
                )}
              </>
            ) : (
              <></>
            )}
          </Modal>
        </>
      )}
    </>
  );
};

export default ContactModal;
